module.exports = __webpack_public_path__ + "img/accounts-default.74502bfb.svg";